import { StepAction } from './stepAction';
import type { UserCodeStep } from 'clickim/src/common/models/userCodeStep';
import type { ExtendedSfdcContext } from 'clickim/src/common/playback/stepPlayers/sfdcBaseStepPlayback';

export class SfdcInternalTestStepAction extends StepAction<UserCodeStep, ExtendedSfdcContext> {
    override async performAction() {
        const { sfdc } = this.sessionPlayerInit;
        const page = sfdc.sfdcNewSePage(this.driver as any, this.context.sfdcLogHandler);
        try {
            await sfdc.sfdcExecuteJavascript(page, this.step.code || '', this.context);
            return { success: true };
        } catch (err) {
            return {
                success: false,
                reason: err.reason || err.message,
                exception: err,
                shouldRetry: false,
            };
        } finally {
            page.releaseObjects();
        }
    }
}
